import React, { useState, useCallback, useRef } from 'react';
import Webcam from 'react-webcam';
import { MdCameraswitch, MdCamera } from "react-icons/md";
import { IoReloadSharp } from "react-icons/io5";
import styles from './ReactWebcam.module.css';

const ReactWebcam = ({ capturedImage, setCapturedImage }) => {
  const webcamRef = useRef(null);
  const [facingMode, setFacingMode] = useState("environment");
  const [isCameraActive, setIsCameraActive] = useState(capturedImage ? false : true);

  const capture = useCallback(() => {
    const video = webcamRef.current.video;
  
    const videoWidth = video.videoWidth;
    const videoHeight = video.videoHeight;
   
    let targetWidth = 720;
    let targetHeight = 1280;
  
    if (videoWidth > videoHeight) {
      // Landscape mode
      targetWidth = 1280;
      targetHeight = 720;
    } else {
      // Portrait mode or square mode
      targetWidth = 720;
      targetHeight = 1280;
    }
  
    const imageSrc = webcamRef.current.getScreenshot({
      width: targetWidth,
      height: targetHeight,
      quality: 0.9
    });
  
    setCapturedImage(imageSrc);
    setIsCameraActive(false);
  }, [webcamRef, setCapturedImage]);

  const retakePhoto = () => {
    setCapturedImage(null);
    setIsCameraActive(true);  // Re-enable the camera view
  };

  const toggleFacingMode = () => {
    setFacingMode((prevFacingMode) => (prevFacingMode === "environment" ? "user" : "environment"));
  };

  const videoConstraints = {
    width: 1280,
    height: 720,
    facingMode: facingMode,
  };

  return (
    <div>
      {isCameraActive ? (
        <>
          <button onClick={toggleFacingMode} className={styles['btn-switch-cam']}>
            <MdCameraswitch />
          </button>
          <Webcam
            audio={false}
            ref={webcamRef}
            screenshotFormat="image/jpeg"
            screenshotQuality={0.9}
            videoConstraints={videoConstraints}
            className={styles['web-cam']}
          />
          <div className={styles['capture-photo-container']}>
            <button onClick={capture}>
              <MdCamera />
            </button>
          </div>
        </>
      ) : (
        <>
          {capturedImage && (
            <img
              src={capturedImage}
              alt="Captured"
              className={styles['captured-image']}
            />
          )}
          <div className={styles['capture-photo-container']}>
            <button onClick={retakePhoto}>
              <IoReloadSharp />
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default ReactWebcam;
